import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const TextWithButton = ({ blok }) => (
  <div style={{ backgroundImage: `url(${blok.backgroundImage?.filename})`,
  backgroundSize: 'cover',
  backgroundPosition: 'top',
  backgroundRepeat: 'no-repeat'
  }} className="">

  <div className="textwithbutton-wrap flex inner-wrap" {...storyblokEditable(blok)}>
    <div className="textwithbutton-wrap-content flex">
      <div className="textwithbutton-content flex flex-col">
        <h2 className="textwithbutton-subheadline text-5xl">{blok.subheadline}</h2>
        <h2 className="textwithbutton-subheadlineTwo text-5xl">{blok.subheadline2}</h2>
        <h2 className="textwithbutton-subheadlineThree text-5xl">{blok.subheadline3}</h2>

        <p className="textwithbutton-text">{blok.text}</p>

        <div className="textwithbutton-button">
         {blok.link && (<Link href={blok.link} ><button>{blok.button}</button></Link>)} 
         {blok.linknewtab && (<Link href={blok.linknewtab} target="_blank" ><button>{blok.buttonnewtab}</button></Link> )}
        </div>
      </div>
    </div>
  </div>
  </div>
);

export default TextWithButton;
